import { render, staticRenderFns } from "./plant.vue?vue&type=template&id=6c1afe6b&scoped=true"
import script from "./plant.vue?vue&type=script&lang=js"
export * from "./plant.vue?vue&type=script&lang=js"
import style0 from "./treatmentStepTwoTables.styles.scss?vue&type=style&index=0&id=6c1afe6b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1afe6b",
  null
  
)

export default component.exports